<template>
  <div class="pad-cycle-lookup-with-id">
    <div class="mb-10 bold-font">Pad Cycle Lookup With ID</div>
    <el-form ref="form" :model="form" label-width="100px" size="small">
      <el-form-item label="Pad Cycle ID">
        <el-input v-model="form.padCycleId" :min="1" class="wp-100"></el-input>
      </el-form-item>
      <el-button
        class="save-btn min-w-80 mini-btn float-right"
        @click="searchData"
        :loading="loading"
        >Search</el-button
      >
    </el-form>
  </div>
</template>

<script>
import swal from 'sweetalert'
import moment from 'moment-timezone'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      form: {
        padCycleId: ''
      },
      loading: false
    }
  },
  methods: {
    validateForm() {
      if (!this.form.padCycleId) {
        swal({
          icon: 'warning',
          timer: 2000,
          title: 'Warning',
          text: 'Please enter pad cycle id'
        })
        return false
      }
      return true
    },
    searchData() {
      if (this.validateForm()) {
        this.loading = true
        ApiService.GetPadCycleDataWithId(this.form.padCycleId)
          .then(response => {
            this.loading = false
            if (response.data.success) {
              let responseData = response.data.data
              // if no data, the api will return start time and end time as '0001-01-01T00:00:00'
              if (
                !responseData.startTime.includes('0001-01-01') &&
                !responseData.endTime.includes('0001-01-01')
              ) {
                this.$store.commit('pods/SET_SELECTED_DATE', [
                  moment(responseData.startTime, 'YYYY-MM-DDTHH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:s'
                  ),
                  moment(responseData.endTime, 'YYYY-MM-DDTHH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:s'
                  )
                ])
                this.$store.commit(
                  'pods/SET_SELECTED_DATE_QUICK_ACTION',
                  'custom'
                )
                this.$store.commit(
                  'pods/SET_SELECTED_UTC_OFFSET',
                  this.form.utcOffset
                )
              } else {
                swal({
                  icon: 'warning',
                  timer: 2000,
                  title: 'No data was obtained'
                })
              }
            } else {
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed'),
                text: response.data.msg
              })
            }
          })
          .catch(() => {
            this.loading = false
            swal({
              icon: 'error',
              timer: 2000,
              title: 'No data was obtained'
            })
          })
      }
    }
  }
}
</script>

<style lang="scss">
.pad-cycle-lookup-with-id {
  position: absolute;
  margin-top: 330px;
  border-top: 1px solid #d7d7d7;
  padding-top: 10px;

  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    width: 260px;
  }
}
</style>
